import { createContext } from 'react';
const MatomoContext = createContext(null);
export default MatomoContext;
